export default __webpack_public_path__ + "static/media/Img1.d5856f7a.jpg";